import { z } from 'zod'

import { PHONE_REGEXP } from '@/constants'
import { passwordContainsPhonePart } from '@/utils/auth/passwordValidation'

export const ByPhoneFormSchema = z.object({
  phone: z
    .string()
    .trim()
    .min(1, 'Введите номер телефона')
    .regex(
      PHONE_REGEXP,
      'Номер телефона должен быть полным и начинаться с +375'
    ),
})

export const ByPasswordFormSchema = z.object({
  phone: z
    .string()
    .trim()
    .min(1, 'Введите номер телефона')
    .regex(PHONE_REGEXP, 'Введите корректный номер телефона'),
  password: z.string().min(1, 'Введите пароль'),
})

export type LoginFormValues = {
  phone: string
  password?: string
}

export const ResetPasswordFullSchema = z
  .object({
    phone: z
      .string()
      .trim()
      .min(1, 'Введите номер телефона')
      .regex(
        PHONE_REGEXP,
        'Номер телефона должен быть полным и начинаться с +375'
      ),
    password: z.string().min(6, 'Пароль должен содержать минимум 6 символов'),
    repeatPassword: z.string().min(1, 'Подтвердите пароль'),
  })
  .refine((data) => !passwordContainsPhonePart(data.password, data.phone), {
    message: 'Пароль не должен содержать номер телефона или его часть',
    path: ['password'],
  })
  .refine((data) => data.password === data.repeatPassword, {
    message: 'Пароли не совпадают',
    path: ['repeatPassword'],
  })

export type ResetPasswordFormData = z.infer<typeof ResetPasswordFullSchema>
